import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { checkNoChangesView } from '../../../node_modules/@angular/core/src/view/view';


@Directive({
 selector: '[numberOnly]'
})
export class NumberOnlyDirective {
 // Allow decimal numbers and negative values
 private regex: RegExp = new RegExp(/^-?[0-9]+(\[0-9]*){0,1}$/g);
 // Allow key codes for special events. Reflect :
 // Backspace, tab, end, home
 private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home', 'Delete' ];

constructor(private el: ElementRef) {
 }
 @HostListener('keydown', [ '$event' ])
 onKeyDown(event: KeyboardEvent) {
 // Allow Backspace, tab, end, and home keys
 if (this.specialKeys.indexOf(event.key) !== -1) {
 return;
 }
 let current: string = this.el.nativeElement.value;
 let next: string = current.concat(event.key);
 if (next && !String(next).match(this.regex)) {
 event.preventDefault();
 }
 }
}

  @Directive({
    selector: '[phoneMask]',
  })
  export class PhoneMaskDirective {
  
    constructor(public ngControl: NgControl) { }
  
    @HostListener('click', ['$event'])
    OnNgModelload(event) {
      this.onInputChange(event.target.value, false);
    }
    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
      this.onInputChange(event, false);
    }
  
    @HostListener('keydown.backspace', ['$event'])
    keydownBackspace(event) {
      this.onInputChange(event.target.value, true);
    }

    @HostListener('keyup', ['$event'])
    keyupevent(event) {
      this.onInputChange(event.target.value, null);
    }
    
  
    onInputChange(event, backspace) {
      let newVal = event.replace(/\D/g, '');
      if (backspace != null && backspace && newVal.length <= 6) {
        newVal = newVal.substring(0, newVal.length - 1);
      }
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
      } else if (newVal.length <= 10) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3');
      } else {
        newVal = newVal.substring(0, 10);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3');
      }
      if( backspace == null )
      {
        this.ngControl.control.patchValue(newVal);
      }
      else
        this.ngControl.valueAccessor.writeValue(newVal);
    }
  }


  @Directive({
    selector: '[alphaOnlyLessRestricted]'
   })
   export class AlphaOnlyLessRestricted {
  // \w matches letters, digits, and underscores
  // \s matches spaces, tabs, and line breaks
  // - matches the hyphen
    private regex: RegExp = new RegExp(/^[-\w\s]+$/);
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End','Delete', 'Home'];
   
   constructor(private el: ElementRef) {
    }
    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
    return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
    event.preventDefault();
    }
    }
   }
   
   